import * as XLSX from "xlsx";
import { SourceDetailLinkRow } from "../../../store/overview/types";
import { EXCEL_LINKS_FILENAME, EXCEL_LINKS_SHEET_NAME } from "../const";

function linksToExcelData(rows: SourceDetailLinkRow[]): Record<string, string | number>[] {
  return rows.map((row) => ({
    "#": row.index,
    URL: row.url,
    Title: row.title,
    Mentioned: row.is_mentioned ? "Yes" : "No",
    User: row.user,
    Citations: row.citations,
    "Response date": row.response_date,
  }));
}

/**
 * Builds an Excel workbook from source detail links and triggers file download.
 */
export function exportLinksToExcel(rows: SourceDetailLinkRow[]): void {
  const data = linksToExcelData(rows);
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, EXCEL_LINKS_SHEET_NAME);
  XLSX.writeFile(wb, EXCEL_LINKS_FILENAME);
}
